module.exports = __webpack_public_path__ + "img/background-img.6c8e781e.jpg";